import { FC, JSXElementConstructor, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Grid } from "@mui/material";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import { JsxChild, JsxElement } from "typescript";

interface IDialogInfoProps {
 children: any;
  title?: string;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
}

export const DialogInfo: FC<IDialogInfoProps> = (props) => {
  const handleClickOpen = () => {
    props?.setOpen(true);
  };

  const handleClose = () => {
    props?.setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item p={1} justifyContent="flex-start">
            <LiveHelpIcon fontSize="large" color="info" />
          </Grid>
          <Grid item>
            <DialogTitle id="responsive-dialog-title">
              {props?.title}
            </DialogTitle>
          </Grid>
        </Grid>

        <DialogContent>
          <>{props.children}</>
        </DialogContent>
        <DialogActions>
          {/* <Button autoFocus onClick={handleClose}>
            Disagree
          </Button> */}
          <Button onClick={handleClose} autoFocus>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
